<div class="dashboard-container container" fxFill fxLayout="column" fxLayoutAlign="center center">
  <img src="/assets/images/dashboard-wip.png" style="width:100%" alt="wip-dashboard"/>
  <div class="coming-soon-panel mat-elevation-z1 container default-padding" fxLayout="column"
       fxLayoutAlign="center center">
    <h1 class="mat-h1">{{ 'DASHBOARD.COMING_SOON' | translate }}</h1>
    <p>{{ 'DASHBOARD.DESCRIPTION' | translate }}</p>
  </div>
</div>
